import {Injectable} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {CommonService} from './common.service';

@Injectable({
    providedIn: 'root'
})
export class StudentsService {
    public students: MatTableDataSource<any> = new MatTableDataSource<any>();

    constructor(private commonService: CommonService) {
    }
}
